export default {
  user: {},
  token: '',
  email: '',
  password: '',
  process: false,
  successMessage: false,
  errorMessage: false,
  DialodPermissionDenied: false,
}
